import React from "react";
import "./Event.css";

const events = [
  {
    img: "images/event/nabajagaran.jpg",
    text: `On 2nd August at Sishir Mancha, Techno India Group will host a cultural
    evening celebrating Bengal’s "New Awakening" through music and poetry,
    honoring three distinguished achievers.`,
  },
  {
    img: "images/event/Dear_maa.jpg",
    text: `Students of Sister Nivedita University and Techno International New Town
    attended a special premiere of Dear Maa at INOX, City Centre 1, Salt Lake.
    Techno India Group Founder & MD and SNU Chancellor, Mr. Satyam Roychowdhury,
    also attended the event.`,
  },
  {
    img: "images/event/fair.jpg",
    text: `The concluding chapter of the APAI-WB Pre-Counselling & Education Fair 2025,
    held on 4th & 5th July at Netaji Indoor Stadium, featured leading edupreneurs
    sharing their vision for the future of engineering education in West Bengal.`,
  },
  {
    img: "images/event/sports.jpg",
    text: `A historic milestone for Techno India Group as the Netaji Subhash University
    of Sports and Entrepreneurship Bill 2025 was passed in the West Bengal State
    Legislative Assembly on 23rd June.`,
  },
  {
    img: "images/event/fair_durgapur.jpg",
    text: `The APAI Pre-Counselling Fair was held in Durgapur on 21st June 2025,
    guiding aspiring students with valuable insights into engineering and
    technical education opportunities across West Bengal.`,
  },
  {
    img: "images/event/fairsiliguri.jpg",
    text: `The APAI Pre-Counselling & Education Fair 2025 was inaugurated in Siliguri
    on 9th June, launching a series of student-focused sessions across
    Paschim Medinipur, Durgapur, and Kolkata.`,
  },
  {
    img: "images/event/Wace.jpg",
    text: `On 9th June 2025, Techno India Group World School Siliguri launched the
    Western Australian Certificate of Education (WACE), unlocking global
    education opportunities for students of North Bengal.`,
  },
  {
    img: "images/event/football.jpg",
    text: `On 26th March 2025, Techno India Group partnered with City Football Group
    to launch the first-ever Manchester City Football School in Kolkata, India.`,
  },
];

const Event = () => {
  return (
    <>
      {/* Inner Banner */}
      <div className="inner-banner-wrapper">
        <img
          src="images/page-banner/gallery.png"
          alt="Event Banner"
          className="inner-banner-img"
        />
        <div className="inner-banner-overlay">
          <div className="inner-banner-text">Event</div>
        </div>
      </div>

      <div className="overview-container">
        <div className="inner-event-container">
          <div className="inner-event-grid">
            {events.map((event, index) => (
              <div className="inner-event-card" key={index}>
                <div className="inner-event-image-wrapper">
                  <img src={event.img} alt={`Event ${index + 1}`} />
                </div>
                <p className="inner-event-caption">{event.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Event;